import { createFileRoute } from '@tanstack/react-router'

import { LandingPage } from '@/pages/landing/landing'

export const Route = createFileRoute('/')({
	component: LandingPage,
	ssr: true,
})
